export const REQUEST_IN_PROGRESS = 'action/merchant_and_agent/request_in_progress';
export const REQUEST_DONE = 'action/merchant_and_agent/request_done';
